import { render, staticRenderFns } from "./twoPaymentPlans.vue?vue&type=template&id=ce6c1354&"
import script from "./twoPaymentPlans.vue?vue&type=script&lang=js&"
export * from "./twoPaymentPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports